module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }, [_c('h1', {
    staticClass: "toc_head"
  }, [_vm._v("CONTENTS")])]), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/004_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/005_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/006_FM1"
    }
  }, [_vm._v("Map\t")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1"
    }
  }, [_vm._v("The Far North Line, Inverness to Dingwall")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Far North Line, Dingwall to Wick and Thurso")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dingwall To Kyle of Lochalsh")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("South from Inverness")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Highland Main Line, Inverness to Perth")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inverness to Aberdeen and Dundee")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The West Highland Line, Dumbarton to Mallaig")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The West Highland Line, Crianlarich to Oban")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dundee to Perth and Edinburgh, including freight operations based on Thornton Junction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/016_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Larbert to Perth, including the Cambus branch")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/017_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edinburgh towards Glasgow, including Falkirk area freight")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/018_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edinburgh towards Berwick-upon-Tweed, including branch lines")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/019_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edinburgh to Carstairs")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/020_Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Around Glasgow")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/021_Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("South-West Scotland")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/022_Chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The West Coast Main Line")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/023_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0